import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { SignFormOptions } from '#src/app/pages/petitionDetails/shared/types';
import { useLoginStateAsync } from '#src/app/shared/hooks/session';
import type { StateWithoutError } from '#src/app/shared/utils/async';
import { isLoading } from '#src/app/shared/utils/async';

type Result = StateWithoutError<Pick<SignFormOptions, 'coiReminder'>>;

export function useCoiReminder(): Result {
	const {
		data: {
			featureConfigs: { doubleOptInEnabled },
		},
	} = usePetitionDetailsPageData();
	const loginState = useLoginStateAsync();

	const loadingState = useMemo(() => ({ status: 'loading' as const }), []);

	return useMemo(() => {
		if (isLoading(loginState)) return loadingState;

		return {
			status: 'loaded',
			coiReminder: {
				enabled: doubleOptInEnabled && loginState.value === 'GUEST',
			},
		};
	}, [loadingState, doubleOptInEnabled, loginState]);
}
